import React, { useEffect, useState } from "react";
import { Calendar, ArrowRight } from "lucide-react";
import { NEWS } from "../mock";

const TAGS = ["All", "Public Notice", "Enforcement", "Investor Alert", "Market", "Consultation", "Press Release"];

export default function News() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const [filter, setFilter] = useState("All");
  const items = filter === "All" ? NEWS : NEWS.filter((n) => n.tag === filter);

  return (
    <div>
      <section className="hero-pattern text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <h1 className="font-serif text-3xl sm:text-5xl font-bold mb-4">News &amp; Public Notices</h1>
          <p className="text-slate-200 max-w-2xl text-lg">
            Official notices, investor alerts, enforcement actions and press releases from the Commission.
          </p>
        </div>
      </section>

      <section className="bg-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-2 mb-10">
            {TAGS.map((t) => (
              <button
                key={t}
                onClick={() => setFilter(t)}
                className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
                  filter === t ? "bg-brand-navy text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                }`}
              >
                {t}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((n) => (
              <article key={n.id} className="news-card bg-white rounded-xl border border-slate-200 p-6 flex flex-col">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs font-semibold text-brand-green bg-[#eaf4ee] px-2.5 py-1 rounded">{n.tag}</span>
                  <span className="text-xs text-slate-400 inline-flex items-center gap-1"><Calendar size={12} /> {n.date}</span>
                </div>
                <h3 className="font-serif text-lg font-bold text-brand-navy mb-2 leading-snug">{n.title}</h3>
                <p className="text-sm text-slate-500 leading-relaxed mb-4 flex-1">{n.excerpt}</p>
                <button className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-green hover:gap-2.5 transition-all self-start">
                  Read full notice <ArrowRight size={15} />
                </button>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
